import ResizeHandler from './ResizeHandler';

export default ResizeHandler;
